import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../../lib/supabase';
import './AdminLogin.css';

const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL;
const SUPABASE_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY;

export default function AdminLogin() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [step, setStep] = useState('');
  const navigate = useNavigate();

  // Zaten giriş yapılmışsa direkt yönlendir
  useEffect(() => {
    supabase.auth.getSession().then(async ({ data: { session } }) => {
      if (!session) return;
      const { data: profile } = await supabase
        .from('profiles').select('role').eq('id', session.user.id).maybeSingle();
      if (profile?.role === 'admin') {
        navigate('/admin/dashboard', { replace: true });
      }
    });
  }, [navigate]);

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    setLoading(true);
    setStep('Kimlik doğrulanıyor...');

    try {
      // Direkt fetch ile Supabase Auth — client'ın timeout sorununu bypass eder
      const res = await fetch(`${SUPABASE_URL}/auth/v1/token?grant_type=password`, {
        method: 'POST',
        headers: {
          'apikey': SUPABASE_KEY,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email, password }),
        signal: AbortSignal.timeout(10000),
      });

      const authData = await res.json();

      if (!res.ok || authData.error) {
        setError('E-posta veya şifre hatalı: ' + (authData.error_description || authData.msg || authData.error || ''));
        setLoading(false);
        setStep('');
        return;
      }

      // Rol kontrolü — direkt fetch, setSession tetiklemiyor
      setStep('Rol kontrol ediliyor...');
      const profileRes = await fetch(
        `${SUPABASE_URL}/rest/v1/profiles?select=role&id=eq.${authData.user.id}&limit=1`,
        {
          headers: {
            'apikey': SUPABASE_KEY,
            'Authorization': `Bearer ${authData.access_token}`,
          },
          signal: AbortSignal.timeout(8000),
        }
      );
      const profiles = await profileRes.json();
      const role = Array.isArray(profiles) ? profiles[0]?.role : null;

      if (role !== 'admin') {
        setError(`Erişim reddedildi. Mevcut rol: "${role || 'yok'}". Supabase'de role = admin ataması yapın.`);
        setLoading(false);
        setStep('');
        return;
      }

      // Admin onaylandı — şimdi session'ı set et ve yönlendir
      setStep('Yönlendiriliyor...');
      await supabase.auth.setSession({
        access_token: authData.access_token,
        refresh_token: authData.refresh_token,
      });
      navigate('/admin/dashboard', { replace: true });

    } catch (err) {
      console.error('Login error:', err);
      if (err.name === 'TimeoutError' || err.name === 'AbortError') {
        setError('Supabase\'e bağlanılamıyor. Proje duraklatılmış olabilir.');
      } else {
        setError('Hata: ' + err.message);
      }
      setLoading(false);
      setStep('');
    }
  }

  return (
    <div className="admin-login-bg">
      <div className="admin-login-card">
        <div className="admin-login-brand">
          <div className="admin-login-logo">
            <span className="logo-note">Note</span><span className="logo-swapp">Swapp</span>
          </div>
          <p className="admin-login-subtitle">Admin Panel</p>
        </div>

        <h2 className="admin-login-title">Yönetici Girişi</h2>
        <p className="admin-login-desc">Yalnızca yetkili yöneticiler erişebilir.</p>

        <form onSubmit={handleSubmit} className="admin-login-form">
          <div className="afield">
            <label>E-posta</label>
            <input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="admin@noteswapp.com" required autoFocus disabled={loading} />
          </div>
          <div className="afield">
            <label>Şifre</label>
            <input type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="••••••••" required disabled={loading} />
          </div>
          {error && <div className="admin-login-error">{error}</div>}
          <button type="submit" className="admin-login-btn" disabled={loading}>
            {loading ? (step || 'Giriş yapılıyor...') : 'Giriş Yap'}
          </button>
        </form>
      </div>
    </div>
  );
}
